export function calculateDiscountedPrice(price, discountPercentage) {
  const discountAmount = (price * discountPercentage) / 100;
  const discountedPrice = (price - discountAmount).toFixed(2);

  return parseFloat(discountedPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ","));
}
